import { styled } from "styled-components";

const EmptyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:
          color(from var(--d8s-overlay) srgb r g b / 0.99);
`;

const Empty = ({ label = "" }) => {
	return (
		<EmptyWrapper>
			{label && <h2>{label}</h2>}
		</EmptyWrapper>
	);
};

export default Empty;
